import { jwtDecode } from 'jwt-decode';
import type { Token } from '../@types/Token';
import type { Actions } from '../actions';
import { ERR_ACCESS_TOKEN, RCV_ACCESS_TOKEN, REQ_ACCESS_TOKEN } from '../actions/auth';
import { requestStatus, responseStatus } from '../shared/statuses';

interface InitialState {
  requestStatus: number;
  responseStatus: number;
  token?: string | null;
  decodedToken?: Token;
}

export const initialState: InitialState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  token: null,
};

const authReducer = (state: InitialState = initialState, action: Actions): InitialState => {
  switch (action.type) {
    case REQ_ACCESS_TOKEN:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_ACCESS_TOKEN:
      return {
        ...state,
        token: action.response,
        decodedToken: action.response ? jwtDecode<Token>(action.response) : undefined,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case ERR_ACCESS_TOKEN:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default authReducer;
